import React from 'react';
import { Card, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FiInfo } from 'react-icons/fi';
import EndOfStayTable from './EndOfStayTable';
import { END_OF_STAY_SECTION_LABELS, formatScheduledTime } from '../utils/endOfStayLabels';
import { formatReferenceDate } from '../utils/dateHelpers';

const EndOfStaySection = ({ sectionKey, section, loading, compact = false }) => {
    if (!section) return null;

    const label = END_OF_STAY_SECTION_LABELS[sectionKey] || section.scope;
    const scheduledTime = formatScheduledTime(section);
    const dateRange = section.trip_end_date_from && section.trip_end_date_to
        ? `${formatReferenceDate(section.trip_end_date_from)} → ${formatReferenceDate(section.trip_end_date_to)}`
        : null;

    const cronInfo = section.send_method && section.send_path
        ? `${section.send_method} ${section.send_path}`
        : null;

    return (
        <Card className="admin-ds-section-card mb-3">
            <Card.Header>
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        <h6 className="mb-0">
                            {label}
                            {' — envoi planifié '}
                            <span className="text-primary">{scheduledTime}</span>
                        </h6>
                        <Badge bg={section.total > 0 ? 'primary' : 'secondary'}>
                            {section.total ?? section.items?.length ?? 0}
                        </Badge>
                        {cronInfo && (
                            <OverlayTrigger
                                placement="top"
                                overlay={(
                                    <Tooltip id={`eos-cron-${sectionKey}`}>
                                        Cron ops : {cronInfo}
                                        {section.preview_path && (
                                            <>
                                                <br />
                                                Preview : {section.preview_path}
                                            </>
                                        )}
                                    </Tooltip>
                                )}
                            >
                                <span className="text-muted" role="img" aria-label="Info cron" tabIndex={0}>
                                    <FiInfo size={14} />
                                </span>
                            </OverlayTrigger>
                        )}
                    </div>
                    <div className="text-end">
                        {dateRange && (
                            <small className="text-muted d-block">
                                {sectionKey === 'flower'
                                    ? `Fin effective filtrée : ${dateRange}`
                                    : `Fin séjour : ${dateRange}`}
                            </small>
                        )}
                        {sectionKey === 'flower' && (
                            <small className="text-muted d-block">
                                Jour opération = fin effective + 1 jour
                            </small>
                        )}
                    </div>
                </div>
            </Card.Header>
            <Card.Body className="p-0">
                <EndOfStayTable
                    items={section.items || []}
                    loading={loading}
                    compact={compact}
                    sectionKey={sectionKey}
                />
            </Card.Body>
        </Card>
    );
};

export default EndOfStaySection;
